import { environment } from "../../environments/environment";

export const FormioConfig = {
    apiUrl: environment.apiBaseUrl,
    appUrl: "/"
};